module.exports = __webpack_public_path__ + "static/img/ci.d939dcac.svg";